import { render, staticRenderFns } from "./line-animation.vue?vue&type=template&id=628edfdb&scoped=true&"
import script from "./line-animation.vue?vue&type=script&lang=js&"
export * from "./line-animation.vue?vue&type=script&lang=js&"
import style0 from "./line-animation.vue?vue&type=style&index=0&id=628edfdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628edfdb",
  null
  
)

export default component.exports